import { Record } from 'immutable';
import remove from 'lodash/fp/remove';
import * as types from './actionTypes';
import constants from '../constants';

const requestReducerState = Record({
  feedviews: [],
  feedview: {
    id: null,
    Feeds: [],
  },
  tmpFeedview: {},
  [constants.ERROR_KEY]: null,
  [constants.SUCCESS_KEY]: null,
  [constants.FETCHING_KEY]: false,
});

export default (state = requestReducerState(), action) => {
  const { type, payload } = action;
  switch (type) {
    case types.FEEDVIEWS_SUCCESS:
      return state
        .set(constants.ERROR_KEY, null)
        .set(constants.FETCHING_KEY, false)
        .set('feedviews', payload);
    case types.MODIFY_FEEDVIEW_TMP_SUCCESS:
      return state
        .set(constants.ERROR_KEY, null)
        .set(constants.FETCHING_KEY, false)
        .set('tmpFeedview', payload.tmpFeedview);
    case types.FEEDVIEW_SUCCESS:
    case types.CREATE_FEEDVIEW_SUCCESS:
    case types.MODIFY_FEEDVIEW_SUCCESS:
      return state
        .set(constants.ERROR_KEY, null)
        .set(constants.SUCCESS_KEY, null)
        .set(constants.FETCHING_KEY, false)
        .set('feedview', payload);
    case types.DELETE_FEEDVIEW_SUCCESS:
      return state
        .set(constants.ERROR_KEY, null)
        .set(constants.SUCCESS_KEY, null)
        .set(constants.FETCHING_KEY, false)
        .set('feedviews', remove({ id: payload })(state.feedviews));
    case types.FEEDVIEWS_REQUEST:
    case types.FEEDVIEW_REQUEST:
    case types.CREATE_FEEDVIEW_REQUEST:
    case types.MODIFY_FEEDVIEW_REQUEST:
    case types.DELETE_FEEDVIEW_REQUEST:
    case types.RESET_FEEDVIEW:
      return state.set('feedview', requestReducerState().feedview);
    case types.FEEDVIEWS_FAILURE:
    case types.FEEDVIEW_FAILURE:
    case types.CREATE_FEEDVIEW_FAILURE:
    case types.MODIFY_FEEDVIEW_FAILURE:
    case types.DELETE_FEEDVIEW_FAILURE:
      return state
        .set('feedview', requestReducerState().feedview)
        .set(constants.FETCHING_KEY, false)
        .set(constants.ERROR_KEY, payload);
    default:
      return state;
  }
};
